import {createStore} from 'vuex';
import user from './modules/user';
import settings from './modules/settings';
import app from './modules/app';
import getters from './getters';
import permission from './modules/permission';
import dict from './modules/dict'

const store =  createStore({
    modules: {
        user,
        settings,
        app,
        permission,
        dict
    },
    getters
})

export default store;
